// src/app/components/corporate/corporate-filters-bar/corporate-filters-bar.component.ts
import {
   Component,
   EventEmitter,
   Input,
   Output,
   SimpleChanges,
   OnChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CalendarModule } from 'primeng/calendar';
import {
   CorporateDatePreset,
   CorporateFilters
} from '../../../domain/corporate/corporate-filters';
import { Property } from '../../../domain/property';
import { FormsModule } from '@angular/forms';
import { Organisation } from '../../../domain/corporate/organisation';

type PresetOption = { label: string; value: CorporateDatePreset };

@Component({
   selector: 'app-corporate-filters-bar',
   standalone: true,
   imports: [
      CommonModule,
      DropdownModule,
      SelectButtonModule,
      CalendarModule,
      FormsModule
   ],
   templateUrl: './corporate-filters-bar.component.html',
   styleUrls: ['./corporate-filters-bar.component.scss']
})
export class CorporateFiltersBarComponent implements OnChanges {
   @Input() properties: Property[] = [];
   @Input() organisations: Organisation[] = [];
   @Input() organisationId: number | null = null;

   @Output() organisationChanged = new EventEmitter<number | null>();
   @Output() filtersChanged = new EventEmitter<CorporateFilters>();

   selectedOrganisationId: number | null = null;
   selectedPropertyId: number | null = null;
   preset: CorporateDatePreset = 'last30';

   // p-calendar range uses [Date, Date]
   customRange: Date[] | null = null;

   presetOptions: PresetOption[] = [
      { label: 'Last 30 Days', value: 'last30' },
      { label: 'Last 7 Days', value: 'last7' },
      { label: 'Yesterday', value: 'yesterday' },
      { label: 'Custom', value: 'custom' }
   ];

   ngOnChanges(changes: SimpleChanges): void {
      if (changes['organisationId']) {
         this.selectedOrganisationId = this.organisationId ?? null;

         // When org changes (often due to global property change), clear property filter
         this.selectedPropertyId = null;
         this.emitFilters();
      }
   }

   onOrganisationChange(): void {
      this.organisationChanged.emit(this.selectedOrganisationId);

      // clear property selection when switching orgs
      this.selectedPropertyId = null;
      this.emitFilters();
   }

   onPresetChange(): void {
      if (this.preset !== 'custom') {
         this.customRange = null;
      }
      this.emitFilters();
   }

   onPropertyChange(): void {
      this.emitFilters();
   }

   onCustomRangeChange(): void {
      this.emitFilters();
   }

   private emitFilters(): void {
      const start = this.customRange?.[0] ?? null;
      const end = this.customRange?.[1] ?? null;

      const hasCompleteCustomRange = !!start && !!end;

      this.filtersChanged.emit({
         propertyId: this.selectedPropertyId,
         preset: this.preset,
         customStart: hasCompleteCustomRange ? start : null,
         customEnd: hasCompleteCustomRange ? end : null
      });
   }
}
